import { AnyAction, CombinedState, combineReducers } from "@reduxjs/toolkit";
import applicationReducer from "../slices/application";
import authReducer from "../slices/auth";
import sharedReducer from "../slices/shared";
import sampleReducer from "../slices/sample";
import companyReducer from "../slices/company";
import userReducer from "../slices/user";
import hubReducer from "../slices/hub";
import downloadReducer from "../slices/download";
import providerReducer from "../slices/provider";

const combinedReducer = combineReducers({
  application: applicationReducer,
  auth: authReducer,
  shared: sharedReducer,
  sample: sampleReducer,
  company: companyReducer,
  user: userReducer,
  hub: hubReducer,
  download: downloadReducer,
  provider: providerReducer,
});

const rootReducer = (state: CombinedState<any>, action: AnyAction) => {
  // console.log("Action", JSON.stringify(action));
  if (action.type === "auth/logout/fulfilled") {
    return combinedReducer(undefined, action);
  }

  return combinedReducer(state, action);
};

export default rootReducer;
